import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpDataService } from './http-data.service';

@Injectable()
export class LeagueService extends HttpDataService {
  constructor(protected injector: Injector) {
    super(injector, '/kepler/matches');
  }

  getLeague(id: string): Observable<any> {
    return super.getItem(id);
  }

  editLeague(matchId: string, body: any) {
    const url = `${this.baseUrl}/${matchId}/leagues`;
    return super.putRequest(url, body, this.getRequestOptions());
  }
}
